import { StatisticsWidget } from "@/framework/KioForm/widgets/StatisticsWidget";
import type { WidgetProps } from "@rjsf/utils";

export interface StatisticsViewProps {
    pageUrl: string;
}

const StatisticsView = ({ pageUrl }: StatisticsViewProps) => {
    
    const uiSchema = {
        "ui:plausibleUrl": pageUrl,
        "ui:hideQrCodes": pageUrl === "kiosk.kulturio.org" || pageUrl === "dev-kiosk.kulturio.org",
        "ui:hidePagePath": pageUrl === "kiosk.kulturio.org" || pageUrl === "dev-kiosk.kulturio.org",
        "ui:hideOpenPage": pageUrl === "kiosk.kulturio.org" || pageUrl === "dev-kiosk.kulturio.org",
    };

    return <StatisticsWidget uiSchema={uiSchema} {...({} as WidgetProps)} />;
};

export default StatisticsView;
